import { daysUntil } from './dates';

// The one-line summary strip. Returns [] when the list is empty (hide the
// strip), otherwise the non-zero segments, or a single "all clear" segment.
export const summarize = (tasks, today) => {
  if (tasks.length === 0) return [];
  const active = tasks.filter((t) => t.status !== 'complete');
  const counts = {
    overdue: 0, today: 0, in_progress: 0, needs_review: 0,
  };
  active.forEach((t) => {
    const days = daysUntil(t.due_on, today);
    if (days !== null && days < 0) counts.overdue += 1;
    if (days === 0) counts.today += 1;
    if (t.status === 'in_progress') counts.in_progress += 1;
    if (t.status === 'needs_review') counts.needs_review += 1;
  });
  const segments = [];
  if (counts.overdue) {
    segments.push({
      key: 'overdue', count: counts.overdue, label: 'overdue', tone: 'overdue',
    });
  }
  if (counts.today) {
    segments.push({
      key: 'today', count: counts.today, label: 'due today', tone: 'soon',
    });
  }
  if (segments.length === 0) segments.push({ key: 'clear', text: 'Nothing overdue or due today', tone: 'complete' });
  if (counts.in_progress) {
    segments.push({
      key: 'in_progress', count: counts.in_progress, label: 'in progress', tone: 'progress',
    });
  }
  if (counts.needs_review) {
    segments.push({
      key: 'needs_review',
      count: counts.needs_review,
      label: counts.needs_review === 1 ? 'needs review' : 'need review',
      tone: 'review',
    });
  }
  return segments;
};
